import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  action,
}: SectionHeadingProps) {
  const isCenter = align === 'center';

  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end ${
        isCenter ? 'md:flex-col md:items-center' : 'md:justify-between'
      }`}
    >
      <div className={isCenter ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'}>
        {eyebrow && (
          <span className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
            {!isCenter && <span className="h-3 w-1 rounded-full bg-primary-500" aria-hidden="true" />}
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}